const React = require('react');
const { Button, ButtonText } = require('@andes/button');
const Return20 = require('@andes/icons/Return20');
const { useI18n } = require('../../../../utils/context/i18nContext');
const { useUrlState } = require('../../../../utils/context/url');
const { string } = require('prop-types');

const GoBackButton = ({ platformId }) => {
  const i18n = useI18n();
  const { homeUrl, baseUrl } = useUrlState();
  const mobileScheme = platformId === 'ML' ? 'meli' : 'mercadopago';
  const homeDeepLink = `${mobileScheme}://cx/help?url=${homeUrl}${baseUrl}`;

  const goToHome = () => {
    if (window && window.melidata) {
      window.melidata('cleanAndSend', 'event', {
        path: 'native_go_home_button',
        event_data: {},
      });
    }
  };

  return (
    <Button
      className="cx-peach__goGome"
      data-testid="go-home-btn"
      fullWidth
      hierarchy="transparent"
      href={homeDeepLink}
      onClick={goToHome}
      target="_parent"
    >
      <Return20 color="blue" />
      <ButtonText>{i18n.gettext('Ir al inicio de Ayuda')}</ButtonText>
    </Button>
  );
};

GoBackButton.propTypes = {
  platformId: string.isRequired,
};


module.exports = GoBackButton;
